import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';

export enum SmsTemplateType {
  DEPOSIT_REMINDER = 'DEPOSIT_REMINDER',
  APPOINTMENT_REMINDER = 'APPOINTMENT_REMINDER',
  REVIEW_REQUEST = 'REVIEW_REQUEST',
  // APPOINTMENT_CONFIRMATION = 'APPOINTMENT_CONFIRMATION',
  // CANCELLATION_NOTICE = 'CANCELLATION_NOTICE',
}

export interface SmsTemplate {
  id: string;
  userId: string;
  type: SmsTemplateType;
  content: string;
  automatic?: boolean;
  daysBefore?: number;
  sendTime?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SmsPlaceholder {
  placeholder: string;
  description: string;
}

// Mapping for placeholder translation keys
export const PLACEHOLDER_TRANSLATION_KEYS: Record<string, string> = {
  clientName: 'smsPlaceholder.clientName',
  depositAmount: 'smsPlaceholder.depositAmount',
  serviceName: 'smsPlaceholder.serviceName',
  appointmentDate: 'smsPlaceholder.appointmentDate',
  appointmentTime: 'smsPlaceholder.appointmentTime',
  reviewUrl: 'smsPlaceholder.reviewUrl',
  reason: 'smsPlaceholder.reason',
  bankAccount: 'smsPlaceholder.bankAccount',
};

export interface CreateOrUpdateSmsTemplateRequest {
  type: SmsTemplateType;
  content: string;
  automatic?: boolean;
  daysBefore?: number;
  sendTime?: string;
}

export interface GetAllSmsTemplatesResponse {
  templates: SmsTemplate[];
}

export interface GetSmsPlaceholdersResponse {
  placeholders: Record<SmsTemplateType, SmsPlaceholder[]>;
}

export const smsTemplateApi = {
  getAll: () => '/api/sms-templates',
  getPlaceholders: () => '/api/sms-templates/placeholders',
  createOrUpdate: () => '/api/sms-templates',
  delete: (id: string) => `/api/sms-templates/${encodeURIComponent(id)}`,
};

export const getAllSmsTemplates = async (): Promise<GetAllSmsTemplatesResponse> =>
  apiCall(
    async () => await axiosInstance.get(smsTemplateApi.getAll()),
    'Nepovedlo se načíst SMS šablony.',
  );

export const getSmsPlaceholders = async (): Promise<GetSmsPlaceholdersResponse> =>
  apiCall(
    async () => await axiosInstance.get(smsTemplateApi.getPlaceholders()),
    'Nepovedlo se načíst placeholdery.',
  );

export const postCreateOrUpdateSmsTemplate = async (
  data: CreateOrUpdateSmsTemplateRequest,
): Promise<SmsTemplate> =>
  apiCall(
    async () => await axiosInstance.post(smsTemplateApi.createOrUpdate(), data),
    'Nepovedlo se uložit SMS šablonu.',
  );

export const deleteSmsTemplate = async (id: string): Promise<void> =>
  apiCall(
    async () => await axiosInstance.delete(smsTemplateApi.delete(id)),
    'Nepovedlo se smazat SMS šablonu.',
  );

// Výchozí SMS šablony (fallback když uživatel nemá vlastní)
export const DEFAULT_SMS_TEMPLATES: Record<SmsTemplateType, string> = {
  [SmsTemplateType.DEPOSIT_REMINDER]:
    'Dobrý den {clientName}, připomínáme platbu zálohy {depositAmount} na účet {bankAccount} za službu {serviceName}, která je naplánována na {appointmentDate}. Prosíme o její uhrazení. Děkujeme',
  [SmsTemplateType.APPOINTMENT_REMINDER]:
    'Dobrý den {clientName}, připomínáme návštěvu na službu {serviceName} dne {appointmentDate} v {appointmentTime}. Těšíme se na Vás.',
  [SmsTemplateType.REVIEW_REQUEST]:
    'Dobrý den {clientName}, děkujeme za Vaši návštěvu. Budeme rádi za Vaše hodnocení a zpětnou vazbu. Zde odkaz: {reviewUrl} Děkujeme.',
  // [SmsTemplateType.APPOINTMENT_CONFIRMATION]:
  //   'Dobrý den {clientName}, potvrzujeme Váš termín na službu {serviceName} dne {appointmentDate} v {appointmentTime}. Těšíme se na Vás.',
  // [SmsTemplateType.CANCELLATION_NOTICE]:
  //   'Dobrý den {clientName}, bohužel musíme zrušit návštěvu dne {appointmentDate} v {appointmentTime}. Důvod: {reason}. Omlouvám se za komplikace.',
};
